import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Tab, Tabs, TextField, Typography, CircularProgress, } from '@mui/material';
import LeftSidebar from '../partials/leftSidebar';
import Row from 'react-bootstrap/Row';
import { FieldArray, Formik, Form, Field, ErrorMessage } from 'formik';
import { CheckboxWithLabel } from 'formik-material-ui';
import { array, object, number, string, boolean, ValidationError } from 'yup';
import { Form as RBFORM } from 'react-bootstrap';
// import { postMethod } from "../../services/apiService";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Grid from "@mui/material/Grid2";
import Stack from '@mui/material/Stack';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import OrderDetailTabOne from './orderDetailTabs/OrderDetailTabOne';
import OrderDetailTabTwo from './orderDetailTabs/OrderDetailTabTwo';
import OrderDetailTabThree from './orderDetailTabs/OrderDetailTabThree';
import "./orders.css"
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import blueEditicon from "../../assets/images/icon/blue-editicon.svg"
import deleteIcon from "../../assets/images/icon/delete-icon.svg"
import ConfirmationModal from '../partials/ConfirmationModal';

import {  Fade, Modal } from "@mui/material";
// import Image from "next/image";
import closeIcon from "../../assets/images/close.svg";
import { deleteMethod } from '../../services/apiService';
import { ToastContext, useToastContext } from '../../context/toastContext';
import Header from '../partials/header';
import { getUserPriority } from '../../services/authService';
import { PROFILE_TYPE } from '../../helper/globalConstant';

const styleModal = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "420px",
    backgroundColor: "#1D292E",
    borderRadius: "8px",
    padding: "24px",
    boxShadow: "2px 2px 20px 2px #FFFFFF14"
};



interface Order {
    id: string;
    name: string;
    // Add other properties of the `order` object here
}

function OrderDetails() {
    const location = useLocation();
    const { order, siteOrderId, siteId  } = location.state || {};
    const { setToast } = useToastContext() as ToastContext;
    const navigate = useNavigate();

    // const [orderData, setOrderData] = useState([])
    const [orderData, setOrderData] = useState<Order[]>([]); // Array of Order objects

    const [activeTab, setActiveTab] = useState(0);
    const [isEditable, setIsEditable] = useState(false);
    const [userPriority, setUserPriority] = useState<number>();

    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [confirmationMultiDelete, setConfirmationMultiDelete] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        const priority = getUserPriority();
        setUserPriority(priority);
    }, []);

    const handleToggleEdit = () => {
        setIsEditable((prevState) => !prevState);
    };
    const handleTabChange = (event: any, newValue: any) => {
        setActiveTab(newValue);
    }
    useEffect(() => {
        setOrderData([order])
    }, [order])



const handleClose = () => {
    setConfirmationModalOpen(false)
};

const handleDelete = () => {
    // setConfirmation(true);
    setConfirmationModalOpen(true)
};

const handleDeleteModal = async () => {
    let apiEndpoint = "";
    const isPartnerOrder = (userPriority === PROFILE_TYPE.SUPER_ADMIN || userPriority === PROFILE_TYPE.DISTRIBUTOR);

    switch (activeTab) {
        case 0:
            if (isPartnerOrder) {
                const hasValidSiteOrderId = (typeof siteOrderId === 'string' && siteOrderId) || (Array.isArray(siteOrderId) && siteOrderId.length > 0 ? siteOrderId[0] : undefined);
                const targetOrderId = order?.partnerOrderId || order?.vPartnerOrder?.partnerOrderId || order?.vPartnerOrder?.orderId || order?.vSiteOrder?.orderId || order?.orderId || hasValidSiteOrderId;
                apiEndpoint = `/partner/order/${targetOrderId}`;
            } else {
                const hasValidSiteOrderId = (typeof siteOrderId === 'string' && siteOrderId) || (Array.isArray(siteOrderId) && siteOrderId.length > 0 ? siteOrderId[0] : undefined);
                if (hasValidSiteOrderId)
                    apiEndpoint = `/customer/order/${hasValidSiteOrderId}`;
                else
                    apiEndpoint = `/customer/order/${order?.vSiteOrder?.orderId}`;
            }
            break;
        case 1:
            if (siteId)
                apiEndpoint = `/customer/site/${siteId}`;
            else
                apiEndpoint = `/customer/site/${order?.vSiteOrder?.siteId}`;
            break;
        default:
            console.log("Invalid active tab");
            return;
    }

    try {
        console.log("API Endpoint:", apiEndpoint);
        const response = await deleteMethod(apiEndpoint);
        setToast(response?.data?.message, "success");
        navigate("/orders")
        setConfirmationModalOpen(false)

        if (true) {
            console.log("Delete Success:", "response");
        } else {
            throw new Error("Failed to delete");
        }
    } catch (error) {
        console.error("Error deleting:", error);
    }
};

const breadCrumb =[{
	label: "Orders",
	path:'/orders'
  },
  {
	label: "Details",
	path:"/orders/details"
  },
]


    const isPartnerOrder = (userPriority === PROFILE_TYPE.SUPER_ADMIN || userPriority === PROFILE_TYPE.DISTRIBUTOR);

    return (
        <Box sx={{ display: 'flex' }}>
            <LeftSidebar />
            <Header title="" breadCrumb={breadCrumb}/>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    padding: '0',
                    marginTop: 4,

                }}
            >
                <Box sx={{ p: 3 }}>
                    {/* <ConfirmationModal
                        open={confirmationModalOpen}
                        title="Delete Order"
                        message="All the sites / devices associated with this customer and the related licenses will be deleted. Are you sure you want to delete this order?"
                        setConfirmation={setIsDeleting}
                        setConfirmationModalOpen={setConfirmationModalOpen}
                        optionOne="Cancel"
                        optionTwo="Delete"
                    /> */}
                    <Box sx={{ display: 'flex', justifyContent: "space-between", mt: 4 }}>
                        <Typography variant="h5" sx={{ mb: 2 }}>Order</Typography>
                        {/* <Button variant="outlined" color="error" sx={{ mr: 2 }}>Delete</Button> */}
                        {activeTab !== 2 && userPriority !== PROFILE_TYPE.SUPER_ADMIN && userPriority !== PROFILE_TYPE.DISTRIBUTOR && <Stack
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            gap="4px"
                            fontSize={"14px"}
                            style={{
                                padding: "8px 12px",
                                cursor: "pointer",
                                color: "#17B2EB",
                            }}
                            onClick={() => handleDelete()}
                        >
                            <img src={deleteIcon} alt="delete Icon" />
                            Delete
                        </Stack>
                        }
                    </Box>

                    <TabContext value={activeTab.toString()}>
                    <Box sx={{ borderBottom: 1, borderColor: '#313838', }}>

                        <Tabs value={activeTab} onChange={handleTabChange} indicatorColor="primary"
                            textColor="inherit"
                            aria-label="basic tabs example"
                            variant="fullWidth">
                            <Tab label="Order Details" value={0} style={{textTransform: "none"}} />
                            {!(userPriority === PROFILE_TYPE.SUPER_ADMIN || userPriority === PROFILE_TYPE.DISTRIBUTOR) && (
                                <Tab label="Site / Device" value={1} style={{textTransform: "none"}} />
                            )}
                            <Tab label="Licenses" value={2} style={{textTransform: "none"}} />
                        </Tabs>
                        </Box>
                        {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>

                            {isEditable && <Box type="submit" onClick={handleToggleEdit} sx={{ backgroundColor: 'transparent', border: '1px solid #0B4A62', paddingInline: '16px', paddingBlock: '12px', borderRadius: '30px', cursor: 'pointer', color: '#0699CE', fontSize: '14px', fontWeight: 500, mr: 2 }} >
                                Save Changes
                            </Box>}
                            <Box onClick={handleToggleEdit} sx={{ backgroundColor: 'transparent', border: `${isEditable ? '0px solid #0B4A62' : '1px solid #0B4A62'}`, paddingInline: '16px', paddingBlock: '12px', borderRadius: '30px', cursor: 'pointer', color: '#0699CE', fontSize: '14px', fontWeight: 500, }} >
                                {isEditable ? "Cancel" : <><img src={blueEditicon} alt='edit' />&nbsp;&nbsp; Edit</>}
                            </Box>
                        </Box> */}

                        {/* Order Details Content */}

                        <TabPanel value="0"   >
                            <OrderDetailTabOne  />
                        </TabPanel>
                        {!(userPriority === PROFILE_TYPE.SUPER_ADMIN || userPriority === PROFILE_TYPE.DISTRIBUTOR) && (
                            <TabPanel value="1"  >
                                <OrderDetailTabTwo  />
                            </TabPanel>
                        )}
                        <TabPanel value="2"  >
                            <OrderDetailTabThree />
                        </TabPanel>



                    </TabContext>
                </Box>
            </Box>
            <Modal
            open={confirmationModalOpen}
            onClose={handleClose}
            closeAfterTransition
            BackdropProps={{ timeout: 500 }}
        >
            <Fade in={confirmationModalOpen}>
                <Box sx={styleModal}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography sx={{ color: '#E2E3E3', fontWeight: 500, fontSize: '20px' }}>
                       {activeTab === 0 ? "Delete Order":"Delete Site / Device"}
                        </Typography>
                        <img src={closeIcon} alt="close icon" onClick={handleClose} style={{ cursor: 'pointer' }} />
                    </Stack>
                    <Box sx={{ my: '16px', py: '16px', borderTop: '1px solid #313838' }}>
                        <Typography>All the sites / devices associated with this customer and the related licenses will be deleted. Are you sure you want to delete this order?</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'end', gap: '12px' }}>
                        <Box 
                            sx={{minWidth: 70, textAlign: 'center', cursor: 'pointer', color: '#17B2EB', fontSize: '14px', fontWeight: 500, border: '1px solid #0B4A62', padding: '12px', borderRadius: '30px' }}
                            onClick={handleClose}
                            className="hoverBtn"
                        >
                            Cancel
                        </Box>
                        <Box
                            sx={{minWidth: 70, textAlign: 'center', backgroundColor: '#17B2EB', padding: '12px', borderRadius: '30px', cursor: 'pointer', color: '#1E2121', fontSize: '14px', fontWeight: 500, margin:'0' }}
                            onClick={handleDeleteModal}
                        >
                          Delete
                        </Box>
                    </Box>
                </Box>
            </Fade>
        </Modal>

        </Box>
    )
}

export default OrderDetails